// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qop2","left":"styles_left__GrT5r","desktopActions":"styles_desktopActions__2KlsA","title":"styles_title__3tton"};